// @ts-nocheck

import React, { useCallback, useMemo } from 'react';

import { StorageKeys } from '../../../../constants/storage';
import { useLocalStorage } from '../../../../hooks';
import useMergeProps from '../../../../hooks/useMergeProps';

import BetslipOptionsShareSettingsItem from './BetslipOptionsShareSettingsItem';

const BetslipOptionsShareSettingsItemContainer = () => {
  const [showNickname, setShowNickname] = useLocalStorage(StorageKeys.USER_PREFS_SHARE_NICKNAME, true);
  const [showStack, setShowStack] = useLocalStorage(StorageKeys.USER_PREFS_SHARE_STACK, true);

  const onToggleImagePseudo = useCallback(() => {
    setShowNickname(!showNickname);
  }, [setShowNickname, showNickname]);

  const onToggleImageStack = useCallback(() => {
    setShowStack(!showStack);
  }, [setShowStack, showStack]);

  const otherProps = useMemo(
    () => ({
      isImagePseudoToggled: showNickname,
      onToggleImagePseudo,
      isImageStackToggled: showStack,
      onToggleImageStack,
    }),
    [onToggleImagePseudo, onToggleImageStack, showNickname, showStack],
  );

  const enhancedProps = useMergeProps({ otherProps });

  return <BetslipOptionsShareSettingsItem {...enhancedProps} />;
};

export default BetslipOptionsShareSettingsItemContainer;
